import React, { useEffect, useState } from 'react';
import AppRouter from './routes/AppRouter';
import BottomNavBar from './components/commons/BottomNavBar';
import { getItem } from './utils/localStorage';
import { runOneSignal } from './utils/OneSignalInitializer';
import Analytics from './utils/analytics';
import { useLocation } from 'react-router-dom';
import NonIdealState from 'lqa-ui/lib/Components/NonIdealState';
import { isBrowser } from 'react-device-detect';
import NoInternet from './components/NoInternet';
import PageViewTracker from './components/PageViewTracker/PageViewTracker';
import { AppWrapper } from './app/pages/AppWrapper';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorBoundaryComponent } from './app/common/sharedComponents/ErrorBondaryComponent';
import * as Sentry from '@sentry/react';
import * as Hotjar from './helpers/hotjar';
import 'react-toastify/dist/ReactToastify.css';
import { StyledToastContainer } from './app/common/sharedStyledComponents/GenericStyles.styled';

function App () {
  const isNewAppStructure = getItem('isNewAppStructure');
  const userData = getItem('user');
  const location = useLocation();
  const loc: any = { ...location };
  const isDeactivatedUser: any | null =
    (loc && loc.state && loc.state.isDeactivatedUser) || false;
  const [isOnline, setIsOnline] = useState(true); // Assume online by default

  const checkInternetConnectivity = async () => {
    if (navigator.onLine) {
      setIsOnline(true);
    } else {
      setIsOnline(false);
    }
  };

  useEffect(() => {
    // Call the function initially and then set up an interval to periodically check connectivity
    checkInternetConnectivity();
    if (isOnline) {
      const interval = setInterval(checkInternetConnectivity, 2000); // Check every 2 seconds
      return () => clearInterval(interval); // Cleanup interval on unmount
    } else {
      return;
    }
  }, [isOnline]);
  let isInitialized = false;

  useEffect(() => {
    Analytics.init();
    if (!isInitialized && !!userData && !!userData.user) {
      runOneSignal(userData);
      Analytics.identifyUser((userData.user || {}).id);
      Sentry.setUser({
        id: userData.user.id,
        email: userData.user.userEmail,
        name: `${userData.user.userFirstName} ${userData.user.userLastName}`,
      });
      Hotjar.identifyUser(userData.user.id, {
        email: userData.user.userEmail,
        name: `${userData.user.userFirstName} ${userData.user.userLastName}`,
      });
    }
    return () => {
      isInitialized = true;
    };
  }, []);

  const onRetryClick = () => {
    setIsOnline(true);
    checkInternetConnectivity();
  };

  if (isBrowser) {
    return (
      <div>
        <NonIdealState
          className="Non-ideal-state"
          title="Screen size too large"
          description="Desktop view is not supported, Please use a mobile device."
          icon="illustration-nonideal"
        />
      </div>
    );
  }
  return (
    <ErrorBoundary fallback={<ErrorBoundaryComponent />}>
      <div className="App">
        <PageViewTracker />
        {!isOnline && <NoInternet onRetryClick={onRetryClick} />}
        {!isNewAppStructure && <AppRouter />}
        {!!userData && !isDeactivatedUser && isNewAppStructure && (
          <AppWrapper>
            <AppRouter />
          </AppWrapper>
        )}
        {!isNewAppStructure && !!userData && !isDeactivatedUser && (
          <BottomNavBar />
        )}
      </div>
      <StyledToastContainer />
    </ErrorBoundary>
  );
}

export default App;
